<script lang="ts">
    import { SvelteComponent } from "svelte";

    import Icon from "@components/Icon.svelte";

    export let count = 0;
    export let drawerIcon: typeof SvelteComponent | undefined = undefined;
    export let drawerIconWidth = 40;
    export let drawerIconHeight = 40;
</script>

<div class="gw-drawer-sidebar-header">
    {#if drawerIcon}
        <span class="gw-drawer-sidebar-header__icon">
            <Icon width={drawerIconWidth} height={drawerIconHeight}>
                <svelte:component this={drawerIcon} />
            </Icon>
        </span>
    {/if}

    <div class="gw-drawer-sidebar-header__title">
        <slot />
    </div>

    {#if count}
        <span class="gw-drawer-sidebar-header__count">{count}</span>
    {/if}
</div>

<style>
    .gw-drawer-sidebar-header {
        display: flex;
        align-items: center;
        margin-top: 14px;
    }

    .gw-drawer-sidebar-header__icon {
        display: flex;
        box-sizing: border-box;
        align-items: center;
        justify-content: center;
        height: 2.5em;
        margin-right: 1em;
        padding: 0.75em;
        border-radius: 50%;
        background-color: var(--gw-drawer-btn-icon-bg-color);
    }

    .gw-drawer-sidebar-header__title {
        font-size: 1.25em;
        margin-right: 0.5em;
        line-height: 1em;
    }

    .gw-drawer-sidebar-header__count {
        color: var(--gw-lightgrey-text-color);
    }
</style>
